<template>
  <WidgetWrapper
    lg="6"
    :title="$t('delivery.dashboard.TopVendorDeliveryLate', { count: dataShown })"
    :tooltip-text="$t('delivery.dashboard.TopVendorDeliveryLateTooltip')"
  >
    <template #afterTitle>
      <div class="d-flex gap-3 flex-wrap vendor-filter">
        <b-form-radio-group
          id="btn-radios-1"
          v-model="selected"
          :options="radioGroupOptions"
          name="radios-btn-default"
          buttons
          button-variant="outline-primary"
        ></b-form-radio-group>
      </div>
    </template>
    <b-dropdown
      id="actions-dropdown"
      toggle-tag="div"
      toggle-class="p-0 bg-transparent"
      class="w-auto mb-4"
    >
      <template #button-content>
        <McButton
          variant="secondary"
          icon="icon-outline_chevron-down"
          icon-position="right"
          :text="$t('delivery.dashboard.topData', { count: dataShown })"
        />
      </template>

      <b-dropdown-item
        class="mc-dashboard__order-dropdown"
        v-for="limit in dataLimits"
        :key="limit"
        @click="handleChangeDataShown(limit)"
        :class="{ 'font-weight-bold': limit === dataShown }"
      >
        {{ limit }}
      </b-dropdown-item
      >
    </b-dropdown>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-skeleton-img no-aspect height="400px" />
      </template>
      <b-table
        v-if="selected === 'tabel'"
        sticky-header="400px"
        small
        show-empty
        :fields="fields"
        :items="vendorList"
        responsive
        empty-table
        :empty-text="$t('global.emptyTable')"
      />
      <HorizontalBarChart v-else :options="chartOptions" :labels="labels" :datasets="datasets" />
    </b-skeleton-wrapper>
  </WidgetWrapper>
</template>

<script>
import WidgetWrapper from './WidgetWrapper.vue'
import McButton from '@/components/McButton'
import HorizontalBarChart from '@/components/Chart/HorizontalBar'

import topVendorDeliveryLate from '../lib/fields/topVendorDeliveryLate'

import { getTopVendorWithMostLateDelivery } from '@/services/rest-api/lib/dashboard/delivery-widget'

export default {
  components: {
    WidgetWrapper,
    McButton,
    HorizontalBarChart,
  },
  data() {
    return {
      period: [],
      selected: 'tabel',
      dataShown: 3,
      loading: false,
      vendorList: [],
    }
  },
  computed: {
    fields() {
      return topVendorDeliveryLate()
    },
    datasets() {
      return [
        {
          data: this.vendorList.map((vendor) => vendor.delivery_order_count),
          label: this.$t('delivery.fields.totalLateDelivery'),
          backgroundColor: '#1C74DA',
        },
      ]
    },
    labels() {
      return this.vendorList.map((vendor) => vendor.vendor.name)
    },
    dataLimits() {
      return [3, 5, 10]
    },
    apiClient() {
      return { get: getTopVendorWithMostLateDelivery }
    },
    chartOptions() {
      return {
        legend: { position: 'bottom', labels: { boxWidth: 0 } },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: (value) => {
                  if (Number.isInteger(value)) {
                    return value
                  }
                },
              },
            },
          ],
        },
      }
    },
    radioGroupOptions() {
      return [
        {
          html: `<i class="icon-outline_browser"></i><span>${this.$t(
            'delivery.text.table'
          )}</span>`,
          value: 'tabel',
        },
        {
          html: `<i class="icon-outline_bar-chart-2"></i><span>${this.$t(
            'delivery.text.chart'
          )}</span>`,
          value: 'grafik',
        },
      ]
    }
  },
  mounted() {
    this.handleFetchTopVendorList()
  },
  methods: {
    handleChangeDataShown(count) {
      this.dataShown = count
      this.handleFetchTopVendorList()
    },
    async handleFetchTopVendorList() {
      this.loading = true

      const params = {
        limit: this.dataShown,
      }
      const res = await getTopVendorWithMostLateDelivery(params)

      if (res.errors) return

      this.vendorList = res.data.map((vendor, idx) => ({ ...vendor, number: `${idx + 1}.` }))
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
:deep(input[type='radio']) {
  display: none;

  & + span {
    display: flex;

    i {
      margin-right: 4px;
      font-size: 20px;
    }
  }
}

:deep(.mx-datepicker) {
  width: 215px !important;

  @include xs-screen-only {
    width: 100% !important;
  }
}

:deep(.formulate-input) {
  height: auto;
  padding: 0;
}

.vendor-filter {
  margin-left: auto;
  flex-wrap: wrap;
  justify-content: end;
  width: 100%;

  @include xs-screen-only {
    flex-grow: 1;
    justify-content: center;

    & > * {
      width: 100% !important;
    }
  }
}

:deep(#actions-dropdown) {
  & > * {
    width: 150px !important;
  }

  .dropdown-menu {
    min-width: 0;
  }

  button {
    width: 100%;
    justify-content: space-between;
  }
}
</style>
